import PropTypes from 'prop-types'

/**
 * ArchiveIcon - Outer box with top slot line and down arrow inside (matching user design)
 */
export const ArchiveIcon = ({ size = 14, className = '', style = {} }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
        style={style}
    >
        <rect x="3" y="4" width="18" height="16" rx="3" />
        <line x1="3" y1="9" x2="21" y2="9" />
        <path d="M12 11v5" />
        <path d="m9 13.5 3 3 3-3" />
    </svg>
)

/**
 * UnarchiveIcon - Outer box with top slot line and up arrow inside (matching user design)
 */
export const UnarchiveIcon = ({ size = 14, className = '', style = {} }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
        style={style}
    >
        <rect x="3" y="4" width="18" height="16" rx="3" />
        <line x1="3" y1="9" x2="21" y2="9" />
        <path d="M12 16v-5" />
        <path d="m9 13.5 3-3 3 3" />
    </svg>
)

ArchiveIcon.propTypes = {
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    className: PropTypes.string,
    style: PropTypes.object
}

UnarchiveIcon.propTypes = {
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    className: PropTypes.string,
    style: PropTypes.object
}
